// extracted by mini-css-extract-plugin
module.exports = {"root":"UnreadIndicator_root__SxipA","root_cappedCount":"UnreadIndicator_root_cappedCount__kYDa4"};